import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../../reducers/store';
import { actionFetchPost } from '../../../actions/posts';
import { EditPostDetails, EditPostImage, Loader, PageHeader, ViewUserPost } from '../../../components';

import './editPost.css'

const EditPost = () => {
  const dispatch                        = useDispatch<AppDispatch>();
  const { id }                          = useParams();
  const {isLoading, singlePost }        = useSelector((state: RootState) => state?.postList);
  const [onePost, setOnePost]           = useState(singlePost);
  const lineRef                         = useRef<HTMLDivElement | null>(null);
  const [activeTab, setActiveTab]       = useState<number>(0);
  const tabButtons                      = ['Post', 'Edit post', 'Edit Image'];
  
  useEffect(() => {
    dispatch(actionFetchPost({id}))
  }, [id, dispatch])

  useEffect(() => {
    if (singlePost && singlePost?._id === id) {
      setOnePost(singlePost);
    } else {
      setOnePost(null);
    }
  }, [id, singlePost]);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };
  
  useEffect(() => {
    if (lineRef.current) {
      const parent = lineRef.current.parentNode as HTMLElement;
      const activeButton = parent.querySelector('.active') as HTMLElement;

      if (activeButton) {
        lineRef.current.style.width = `${activeButton.offsetWidth}px`;
        lineRef.current.style.left = `${activeButton.offsetLeft}px`;
      }
    }
  }, [activeTab]);

  return (
    <>
      <title>Edit Post</title>
      <PageHeader title="Edit Post" description="Welcome to the Posts" download="Download Report" />

      <div className='edit-post-wrapper'>
        {isLoading ? (
            <Loader />
          ) : onePost ? (
            <>
              <div className='edit-post-body'>
                <div className='edit-post-tab-box'>
                  {tabButtons.map((tab, index) => (
                    <button key={index} className={`edit-post-tab-btn ${activeTab === index ? 'active' : ''}`} onClick={() => handleTabClick(index)} >
                      {tab}
                    </button>
                  ))}
                  <div className='edit-post-btn-line' ref={lineRef}></div>
                </div>

                <div className='edit-post-content-box'>
                  <div className={`edit-post-content ${activeTab === 0 ? 'active' : ''}`}>
                    <ViewUserPost details={onePost} />
                  </div>
                  <div className={`edit-post-content ${activeTab === 1 ? 'active' : ''}`}>
                    <EditPostDetails id={id} details={onePost} />
                  </div>
                  <div className={`edit-post-content ${activeTab === 2 ? 'active' : ''}`}>
                    <EditPostImage id={id} details={onePost} />
                  </div>
                </div>
              </div>
            </>
            )
           : (
            <><p>Empty data</p></>
            // <EmptyCard title="profile" linkName="Profile" link="/users/create-profile" />
        )}
      </div>
    </>
  )
}

export default EditPost